const locale = 'en-NZ'
const ONE_YEAR = 365
const ONE_DAY = 24 * 60 * 60 * 1000
const MILLISECONDS_IN_DAY = 86400000
const MAX_DAYS_TO_EMPTY = 2 * ONE_YEAR
const debug = !process.env.AWS_SESSION_TOKEN && false

export const getTankWaterHealthData = (fillPercentage: number) => {
  let water_availability = 'E'
  let water_availability_message = 'Data error under investigation'
  switch (true) {
    case fillPercentage >= 75 && fillPercentage <= 100:
      water_availability_message = 'Conserve Water'
      water_availability = 'A'
      return { water_availability, water_availability_message }
    case fillPercentage >= 50 && fillPercentage <= 74:
      water_availability_message = 'Ration water use'
      water_availability = 'B'
      return { water_availability, water_availability_message }
    case fillPercentage >= 25 && fillPercentage <= 49:
      water_availability = 'C'
      water_availability_message = 'Red alert. Control water use'
      return { water_availability, water_availability_message }
    case fillPercentage <= 24:
      water_availability = 'D'
      water_availability_message = 'Only use for drinking'
      return { water_availability, water_availability_message }
    default:
      return { water_availability, water_availability_message }
  }
}

// export const getForecastCollectionData = async (weatherArray: any, effectiveArea: number, yield_Forecast_Average: number) => {
//     // debug &&   console.log({ weatherArray, effectiveArea, yield_Forecast_Average })
//     let forecastArray: { timestamp: number; forecast_collection: number; }[] = []
//     await weatherArray.forEach((arrayData: { timestamp: number; rain: number; }) => {
//         let forecast_collection = typeof arrayData.rain === 'number' ? arrayData.rain * effectiveArea : 0
//         let forecastData = {
//             timestamp: arrayData.timestamp,
//             forecast_collection: forecast_collection,
//             forecast_Collected_Volume: forecast_collection * yield_Forecast_Average
//         }
//         forecastArray.push(forecastData)
//     })
//     //   debug && console.log('forecastArray:', forecastArray)
//     return forecastArray
// }

// export const roundTimestamp = (unixTime: number) => {
//     let date = new Date(unixTime)
//     date.setHours(date.getHours() + Math.round(date.getMinutes() / 60));
//     date.setMinutes(0, 0, 0); // Resets also seconds and milliseconds
//     return date.valueOf() / 1000;
// }

// export const getNewHistoryArray = (historyArray: any, newItem: any) => {
//     // console.log({ historyArray, newItem })
//     historyArray.unshift(newItem);
//     historyArray.pop()
//     return historyArray
// }

// export const getPredictedUsageInHour = (periodVolume: any, usageInHour: any) => {

//     // const currentRoundedTimestamp = roundTimestamp(new Date().valueOf() * 1000)
//     // const currentRoundedDate = new Date(currentRoundedTimestamp)
//     // const currentRoundedHour = currentRoundedDate.getHours()
//     // const currentRoundedDay = currentRoundedDate.getDay()
//     let predicted_Usage_Hour_SimpleArray = []
//     // let predicted_Usage_Hour_MediumArray = []
//     // let predicted_Usage_Hour_ComplexArray = []

//     if (usageInHour.length > 0) {
//         for (let i = 0; i < usageInHour.length; i++) {
//             const usageInPeriod = usageInHour[i + 1] ? (usageInHour[i + 1].usage_In_Period_Assumed > usageInHour[i].usage_In_Period_Assumed) ? (usageInHour[i + 1].usage_In_Period_Assumed - usageInHour[i].usage_In_Period_Assumed) : 0 : 0
//             if (predicted_Usage_Hour_SimpleArray.length <= 100) { predicted_Usage_Hour_SimpleArray.push(usageInPeriod) }
//             if (predicted_Usage_Hour_SimpleArray.length > 100 || i == usageInHour.length - 1) { break }
//         }
//     }
//     if (predicted_Usage_Hour_SimpleArray.length < 100) {
//         for (let i = predicted_Usage_Hour_SimpleArray.length; i < periodVolume.length; i++) {
//             const usageInPeriod = periodVolume[i + 1] ? (periodVolume[i + 1].current_filled_volume > periodVolume[i].current_filled_volume) ? (periodVolume[i + 1].current_filled_volume - periodVolume[i].current_filled_volume) : 0 : 0
//             if (predicted_Usage_Hour_SimpleArray.length <= 100) { predicted_Usage_Hour_SimpleArray.push(usageInPeriod) }
//             if (predicted_Usage_Hour_SimpleArray.length > 100 || i == periodVolume.length - 1) { break }
//         }
//         // else {
//         //     for (let i = 0; i < periodVolume.length; i++) {
//         //         const usageInPeriod = periodVolume[i + 1]? (periodVolume[i + 1].current_filled_volume > periodVolume[i].current_filled_volume) ? (periodVolume[i + 1].current_filled_volume - periodVolume[i].current_filled_volume) : 0:0

//         //         // const roundedUsageInPeriodTimestamp = roundTimestamp(periodVolume[i].timestamp * 1000)
//         //         // const roundedUsageInPeriodDate = new Date(roundedUsageInPeriodTimestamp * 1000)
//         //         // const roundedUsageInPeriodHour = roundedUsageInPeriodDate.getHours()
//         //         // const roundedUsageInPeriodDay = roundedUsageInPeriodDate.getDay()

//         //         // console.log({ usageInPeriod, roundedUsageInPeriodTimestamp, roundedUsageInPeriodDate, roundedUsageInPeriodHour, roundedUsageInPeriodDay, currentRoundedTimestamp, currentRoundedDate, currentRoundedHour, currentRoundedDay })

//         //         if (predicted_Usage_Hour_SimpleArray.length <= 100) { predicted_Usage_Hour_SimpleArray.push(usageInPeriod) }
//         //         if (predicted_Usage_Hour_SimpleArray.length > 100 || i== periodVolume.length - 1) { break }
//         //         // if (predicted_Usage_Hour_MediumArray.length <= 100 &&
//         //         //     roundedUsageInPeriodHour == currentRoundedHour
//         //         // ) { predicted_Usage_Hour_MediumArray.push(usageInPeriod) }
//         //         // if (predicted_Usage_Hour_ComplexArray.length <= 50 &&
//         //         //     roundedUsageInPeriodHour == currentRoundedHour &&
//         //         //     roundedUsageInPeriodDay == currentRoundedDay) { predicted_Usage_Hour_ComplexArray.push(usageInPeriod) }
//         //         // if (predicted_Usage_Hour_ComplexArray.length = 50) break
//         //     }
//     }

//     // console.log('predicted_Usage_Hour_SimpleArray:', predicted_Usage_Hour_SimpleArray)

//     let predicted_Usage_Hour_Simple = ((predicted_Usage_Hour_SimpleArray.reduce((a, b) => a + b, 0)) / predicted_Usage_Hour_SimpleArray.length).toFixed(2)
//     // let predicted_Usage_Hour_Medium = null
//     // let predicted_Usage_Hour_Complex = null
//     // let predicted_Usage_Hour_Medium = (predicted_Usage_Hour_MediumArray.reduce((a, b) => a + b, 0)) / predicted_Usage_Hour_MediumArray.length
//     // let predicted_Usage_Hour_Complex = (predicted_Usage_Hour_ComplexArray.reduce((a, b) => a + b, 0)) / predicted_Usage_Hour_ComplexArray.length

//     // console.log({ predicted_Usage_Hour_Simple, predicted_Usage_Hour_Medium, predicted_Usage_Hour_Complex })
//     // return { predicted_Usage_Hour_Simple, predicted_Usage_Hour_Medium, predicted_Usage_Hour_Complex }
//     return parseInt(predicted_Usage_Hour_Simple)
// }
// export const getPredictedUsageInHour = (rainSensor: boolean, periodVolume: any, usageInHour: any, usageInHourActual:any) => {
//     let predicted_Usage_Hour_SimpleArray = []
//     usageInHourActual = usageInHourActual??[]
//     if (usageInHourActual.length > 0) {
//         for (let i = 0; i < usageInHourActual.length; i++) {
//             const usageInPeriod = usageInHourActual[i + 1] ? (usageInHourActual[i + 1].usage_In_Period_Actual > usageInHourActual[i].usage_In_Period_Actual) ? (usageInHourActual[i + 1].usage_In_Period_Actual - usageInHourActual[i].usage_In_Period_Actual) : 0 : 0
//             if (predicted_Usage_Hour_SimpleArray.length <= 100) { predicted_Usage_Hour_SimpleArray.push(usageInPeriod) }
//             if (predicted_Usage_Hour_SimpleArray.length > 100 || i == usageInHour.length - 1) { break }
//         }
//     }
//     if (usageInHour.length > 0) {
//         for (let i = 0; i < usageInHour.length; i++) {
//             const usageInPeriod = usageInHour[i + 1] ? (usageInHour[i + 1].usage_In_Period_Assumed > usageInHour[i].usage_In_Period_Assumed) ? (usageInHour[i + 1].usage_In_Period_Assumed - usageInHour[i].usage_In_Period_Assumed) : 0 : 0
//             if (predicted_Usage_Hour_SimpleArray.length <= 100) { predicted_Usage_Hour_SimpleArray.push(usageInPeriod) }
//             if (predicted_Usage_Hour_SimpleArray.length > 100 || i == usageInHour.length - 1) { break }
//         }
//     }
//     if (predicted_Usage_Hour_SimpleArray.length < 100) {
//         for (let i = predicted_Usage_Hour_SimpleArray.length; i < periodVolume.length; i++) {
//             const usageInPeriod = periodVolume[i + 1] ? (periodVolume[i + 1].current_filled_volume > periodVolume[i].current_filled_volume) ? (periodVolume[i + 1].current_filled_volume - periodVolume[i].current_filled_volume) : 0 : 0
//             if (predicted_Usage_Hour_SimpleArray.length <= 100) { predicted_Usage_Hour_SimpleArray.push(usageInPeriod) }
//             if (predicted_Usage_Hour_SimpleArray.length > 100 || i == periodVolume.length - 1) { break }
//         }
//     }

//     // console.log('predicted_Usage_Hour_SimpleArray:', predicted_Usage_Hour_SimpleArray)

//     let predicted_Usage_Hour_Simple = ((predicted_Usage_Hour_SimpleArray.reduce((a, b) => a + b, 0)) / predicted_Usage_Hour_SimpleArray.length).toFixed(2)
//      return parseInt(predicted_Usage_Hour_Simple)
// }

// export const getPredictedUsageInDay = (usageInDay: any) => {
//     // let no_of_days = usageInDay.length > 100 ? 100 : usageInDay.length == 0 ? 1 : usageInDay.length
//     console.log('usage in DAy:', usageInDay)
//     let predicted_Usage_Day_SimpleArray = []
//     // let predicted_Usage_Day_MediumArray = []
//     // let predicted_Usage_Day_ComplexArray = []
//     for (let i = 0; i < usageInDay.length; i++) {
//         const DailyUsage = usageInDay[i].Usage_In_Day_Assumed_Hourly ? usageInDay[i].Usage_In_Day_Assumed_Hourly == 0 ? usageInDay[i].usage_in_day : usageInDay[i].usage_in_day : usageInDay[i].usage_in_day   //(usageInDay[i + 1].usage_in_day > usageInDay[i].usage_in_day) ? (usageInDay[i + 1].usage_in_day - usageInDay[i].usage_in_day) : 0
//         if (predicted_Usage_Day_SimpleArray.length <= 100) { predicted_Usage_Day_SimpleArray.push(DailyUsage) }
//         if (predicted_Usage_Day_SimpleArray.length > 100 || i == usageInDay.length - 1) { break }
//     }
//     console.log({ predicted_Usage_Day_SimpleArray })
//     if (predicted_Usage_Day_SimpleArray.length > 0) {
//         let predicted_Usage_Day_Simple = ((predicted_Usage_Day_SimpleArray.reduce((a, b) => a + b, 0)) / predicted_Usage_Day_SimpleArray.length).toFixed(2)
//         console.log({ predicted_Usage_Day_Simple })
//         return parseInt(predicted_Usage_Day_Simple)
//     }
//     else {
//         return 0
//     }

//     //    let average_usage = usageInDay.slice(0, 100).reduce((sum: number, item: any) => sum + item.usage_in_day, 0) / no_of_days
//     // let predicted_Usage_Day_Medium = null
//     // let predicted_Usage_Day_Complex = null

//     //  console.log({ predicted_Usage_Day_Simple, predicted_Usage_Day_Medium, predicted_Usage_Day_Complex })
//     // return { predicted_Usage_Day_Simple, predicted_Usage_Day_Medium, predicted_Usage_Day_Complex }
// }
// export const getPredictedUsageInDay = (rainSensor: boolean, usageInDay: any, usageInDayActual: any) => {

//     // let no_of_days = usageInDay.length > 100 ? 100 : usageInDay.length == 0 ? 1 : usageInDay.length
//     console.log('usage in DAy:', usageInDay)
//     let predicted_Usage_Day_SimpleArray = []
//     // let predicted_Usage_Day_MediumArray = []
//     // let predicted_Usage_Day_ComplexArray = []

//     // timestamp: 1623739171.696,
//     //     usage_in_day: 0,
//     //         usage_in_day_percentage: 0,
//     //             volume_collected_yesterday: 0,
//     //                 Usage_In_Day_Assumed_Hourly: 0,
//     //                     Usage_In_Day_Actual_Hourly:

//     if (rainSensor) {
//         for (let i = 0; i < usageInDayActual.length; i++) {
//             // const DailyUsage = usageInDayActual[i].Usage_In_Day_Assumed_Hourly ? usageInDayActual[i].Usage_In_Day_Assumed_Hourly == 0 ? usageInDayActual[i].usage_in_day : usageInDayActual[i].Usage_In_Day_Assumed_Hourly : usageInDayActual[i].usage_in_day   //(usageInDay[i + 1].usage_in_day > usageInDay[i].usage_in_day) ? (usageInDay[i + 1].usage_in_day - usageInDay[i].usage_in_day) : 0
//             const DailyUsage = getDailyUsage(usageInDayActual[i])
//             console.log('DailyUsage', DailyUsage)
//             if (predicted_Usage_Day_SimpleArray.length <= 100) { predicted_Usage_Day_SimpleArray.push(DailyUsage) }
//             if (predicted_Usage_Day_SimpleArray.length > 100 || i == usageInDayActual.length - 1) { break }
//         }
//     } else {
//         for (let i = 0; i < usageInDay.length; i++) {
//             const DailyUsage = usageInDay[i].Usage_In_Day_Assumed_Hourly ? usageInDay[i].Usage_In_Day_Assumed_Hourly == 0 ? usageInDay[i].usage_in_day : usageInDay[i].Usage_In_Day_Assumed_Hourly : usageInDay[i].usage_in_day   //(usageInDay[i + 1].usage_in_day > usageInDay[i].usage_in_day) ? (usageInDay[i + 1].usage_in_day - usageInDay[i].usage_in_day) : 0
//             if (predicted_Usage_Day_SimpleArray.length <= 100) { predicted_Usage_Day_SimpleArray.push(DailyUsage) }
//             if (predicted_Usage_Day_SimpleArray.length > 100 || i == usageInDay.length - 1) { break }
//         }
//     }
//     console.log({ predicted_Usage_Day_SimpleArray })
//     if (predicted_Usage_Day_SimpleArray.length > 0) {
//         let predicted_Usage_Day_Simple = ((predicted_Usage_Day_SimpleArray.reduce((a, b) => a + b, 0)) / predicted_Usage_Day_SimpleArray.length).toFixed(2)
//         console.log({ predicted_Usage_Day_Simple })
//         return parseInt(predicted_Usage_Day_Simple)
//     }
//     else {
//         return 0
//     }

//     //    let average_usage = usageInDay.slice(0, 100).reduce((sum: number, item: any) => sum + item.usage_in_day, 0) / no_of_days
//     // let predicted_Usage_Day_Medium = null
//     // let predicted_Usage_Day_Complex = null

//     //  console.log({ predicted_Usage_Day_Simple, predicted_Usage_Day_Medium, predicted_Usage_Day_Complex })
//     // return { predicted_Usage_Day_Simple, predicted_Usage_Day_Medium, predicted_Usage_Day_Complex }
// }

// export const getUsageInPeriodAssumed = (previousFillVolume: number, currentFilledVolume: number, currentForecastCollectionHour: any) => {
//     //console.log({  previousFillVolume,currentFilledVolume, currentForecastCollectionHour  });
//     let usage_In_Period_Assumed = 0
//     if (previousFillVolume > currentFilledVolume) {
//         usage_In_Period_Assumed = currentForecastCollectionHour ? (previousFillVolume - currentFilledVolume) + currentForecastCollectionHour.forecast_collection : 0
//     }
//     if (previousFillVolume < currentFilledVolume) {
//         usage_In_Period_Assumed = currentForecastCollectionHour ? currentForecastCollectionHour.forecast_collection - (currentFilledVolume - previousFillVolume) : 0
//     }
//     return usage_In_Period_Assumed
// }

// export const getUsageInDayAssumedHourly = (usageInHour: any, yesterday: string, timeOffset: number) => {
//     let usageInHourYesterday: number = 0
//     for (let i = 0; i < usageInHour.length && i < 50; i++) {
//         const usageInHourDate = getNZDate(usageInHour[i].timestamp, timeOffset)
//         if (usageInHourDate == yesterday) {
//             usageInHourYesterday = usageInHourYesterday + usageInHour[i].usage_In_Period_Assumed
//         }
//     }
//     return usageInHourYesterday
// }

// export const getNZDate = (timestamp: number, timeOffset: number) => {
//     const NZTimeStamp = getNZTime(timestamp, timeOffset)
//     const NZDate = NZTimeStamp.toLocaleDateString(locale)
//     return NZDate
// }

// export const getNZTime = (unixTime: number, timeOffset: number) => {
//     let convertedUNIXTime = unixTime * 1000
//     let NewZealandTime = new Date(convertedUNIXTime + (3600000 * timeOffset));
//     return NewZealandTime
// }

// // export const getDaysLeftToEmpty = async (current_filled_volume: number, forecastCollection: any, periodVolume: any, usageInHour: any, usageInDay: any, recentAverage: number, total_volume: number, currentUnixTime: number) => {

// //     if (current_filled_volume===0 ) return 0
// //     let days_to_runout = recentAverage !== 0 ? Math.min(Math.round(current_filled_volume / recentAverage), 2 * ONE_YEAR) : 2 * ONE_YEAR;
// //     // if (!forecastCollection.length) {
// //     console.log({ days_to_runout, current_filled_volume, recentAverage })
// //     if (forecastCollection?.forecast_Collection_Hour && forecastCollection?.forecast_Collection_Day) {
// //         let predicted_Usage_HourSimple = getPredictedUsageInHour(periodVolume, usageInHour)
// //         let predicted_Usage_DaySimple = getPredictedUsageInDay(usageInDay)
// //         const Predicted_Usage_Hour = predicted_Usage_HourSimple // TODO Have to extend to use Medium and complex
// //         const Predicted_Usage_Day = predicted_Usage_DaySimple // TODO Have to extend to use Medium and complex
// //         if (Predicted_Usage_Day === 0) return days_to_runout

// //         let predictedVolume = current_filled_volume
// //         console.log('Initial Volume ', predictedVolume);
// //         let forecast_Collection_HourArray = forecastCollection?.forecast_Collection_Hour ? forecastCollection?.forecast_Collection_Hour : []
// //         let forecast_Collection_DayArray = forecastCollection?.forecast_Collection_Day ? forecastCollection?.forecast_Collection_Day : []
// //         let dayArray_Filter = currentUnixTime
// //         let daysUntilForecast = 0
// //         //? Remove the trailing incomplete day's timestamp from Hour Array
// //         forecast_Collection_HourArray = getTrimmedHourArray(forecast_Collection_HourArray)
// //         //? removing past timestamps
// //         if (forecast_Collection_HourArray.length > 0) dayArray_Filter = forecast_Collection_HourArray[forecast_Collection_HourArray.length - 1].timestamp
// //         forecast_Collection_HourArray = forecast_Collection_HourArray.filter((hour: { timestamp: number; }) => hour.timestamp > currentUnixTime)
// //         // console.log('forecast_Collection_DayArray  ', forecast_Collection_DayArray);
// //         //? removing past timestamps
// //         forecast_Collection_DayArray = forecast_Collection_DayArray.filter((day: { timestamp: number; }) => day.timestamp > dayArray_Filter)
// //         //? Predicted Volume after hour
// //         predictedVolume = await getPredictedVolume(forecast_Collection_HourArray, predictedVolume, Predicted_Usage_Hour, total_volume)
// //         console.log('Predicted Volume after hour  ', predictedVolume);
// //         //    console.log('forecast_Collection_DayArray  ', forecast_Collection_DayArray);
// //         if (forecast_Collection_DayArray.length > 0) {
// //             //? Predicted Volume after day
// //             predictedVolume = await getPredictedVolume(forecast_Collection_DayArray, predictedVolume, Predicted_Usage_Day, total_volume)
// //             daysUntilForecast = predictedVolume <= 0 ? 0 : daysBetweenDates(currentUnixTime, forecast_Collection_DayArray[forecast_Collection_DayArray.length - 1].timestamp)

// //             console.log('Predicted Volume after day  ', predictedVolume);
// //         }
// //         const daysAfterForecast = predictedVolume <= 0 ? 0 : nos_daysAfterForecast(predictedVolume, Predicted_Usage_Day)
// //         let combinedDays = daysUntilForecast + daysAfterForecast
// //         if (typeof combinedDays === 'number') days_to_runout = combinedDays
// //         console.log({ days_to_runout })
// //     }
// //     return days_to_runout

// // }
// export const getDaysLeftToEmpty = async (current_filled_volume: number, forecastCollection: any, periodVolume: any, usageInHour: any, usageInDay: any,
//     usageInHourActual: any, usageInDayActual: any, recentAverage: number, total_volume: number, currentUnixTime: number, rainSensor: boolean) => {

//     let days_to_runout = recentAverage !== 0 ? Math.min(Math.round(current_filled_volume / recentAverage), 2 * ONE_YEAR) : 2 * ONE_YEAR;
//     // if (!forecastCollection.length) {
//     console.log({ days_to_runout, current_filled_volume, recentAverage })
//     if (forecastCollection?.forecast_Collection_Hour && forecastCollection?.forecast_Collection_Day) {
//         let predicted_Usage_HourSimple = getPredictedUsageInHour(rainSensor, periodVolume, usageInHour, usageInHourActual)
//         let predicted_Usage_DaySimple = getPredictedUsageInDay(rainSensor, usageInDay, usageInDayActual)
//         const Predicted_Usage_Hour = predicted_Usage_HourSimple // TODO Have to extend to use Medium and complex
//         const Predicted_Usage_Day = predicted_Usage_DaySimple // TODO Have to extend to use Medium and complex
//         if (Predicted_Usage_Day === 0) return days_to_runout

//         let predictedVolume = current_filled_volume
//         console.log('Initial Volume ', predictedVolume);
//         let forecast_Collection_HourArray = forecastCollection?.forecast_Collection_Hour ? forecastCollection?.forecast_Collection_Hour : []
//         let forecast_Collection_DayArray = forecastCollection?.forecast_Collection_Day ? forecastCollection?.forecast_Collection_Day : []
//         let dayArray_Filter = currentUnixTime
//         let daysUntilForecast = 0
//         //? Remove the trailing incomplete day's timestamp from Hour Array
//         forecast_Collection_HourArray = getTrimmedHourArray(forecast_Collection_HourArray)
//         //? removing past timestamps
//         if (forecast_Collection_HourArray.length > 0) dayArray_Filter = forecast_Collection_HourArray[forecast_Collection_HourArray.length - 1].timestamp
//         forecast_Collection_HourArray = forecast_Collection_HourArray.filter((hour: { timestamp: number; }) => hour.timestamp > currentUnixTime)
//         // console.log('forecast_Collection_DayArray  ', forecast_Collection_DayArray);
//         //? removing past timestamps
//         forecast_Collection_DayArray = forecast_Collection_DayArray.filter((day: { timestamp: number; }) => day.timestamp > dayArray_Filter)
//         //? Predicted Volume after hour
//         predictedVolume = await getPredictedVolume(forecast_Collection_HourArray, predictedVolume, Predicted_Usage_Hour, total_volume)
//         console.log('Predicted Volume after hour  ', predictedVolume);
//         //    console.log('forecast_Collection_DayArray  ', forecast_Collection_DayArray);
//         if (forecast_Collection_DayArray.length > 0) {
//             //? Predicted Volume after day
//             predictedVolume = await getPredictedVolume(forecast_Collection_DayArray, predictedVolume, Predicted_Usage_Day, total_volume)
//             daysUntilForecast = predictedVolume <= 0 ? 0 : daysBetweenDates(currentUnixTime, forecast_Collection_DayArray[forecast_Collection_DayArray.length - 1].timestamp)

//             console.log('Predicted Volume after day  ', predictedVolume);
//         }
//         const daysAfterForecast = predictedVolume <= 0 ? 0 : nos_daysAfterForecast(predictedVolume, Predicted_Usage_Day)
//         let combinedDays = daysUntilForecast + daysAfterForecast
//         if (typeof combinedDays === 'number') days_to_runout = combinedDays
//         console.log({ days_to_runout })
//     }
//     return days_to_runout

// }

// const getTrimmedHourArray = (forecast_Collection_HourArray: any) => {
//     if (forecast_Collection_HourArray.length > 0) {
//         const TWENTY_FOUR_HOURS: number = 24
//         const firstHourInArrayTimeStamp = new Date(forecast_Collection_HourArray[0].timestamp * 1000)
//         let firstHourInArrayHour = firstHourInArrayTimeStamp.getHours()
//         let no_ValidTimestamps = (TWENTY_FOUR_HOURS + (TWENTY_FOUR_HOURS - firstHourInArrayHour))
//         forecast_Collection_HourArray.length = no_ValidTimestamps
//     }
//     return forecast_Collection_HourArray
// }

// const getPredictedVolume = (collectionArray: any, predictedVolume: number, predictedUsage: number, total_volume: number) => {
//     console.log({
//         // collectionArray, predictedVolume,
//         predictedUsage,
//         // total_volume
//     });

//     collectionArray.forEach((item: any) => {
//         let calculatedPredictedVolume = predictedVolume - predictedUsage + item.forecast_Collected_Volume
//         predictedVolume = (calculatedPredictedVolume > total_volume) ? total_volume : calculatedPredictedVolume
//     });
//     return predictedVolume
// }

// export const daysBetweenDates = (fromUnixTime: number, toUnixTime: number) => {
//     // const fromDate :Date= new Date(fromUnixTime *1000)
//     // const toDate: Date = new Date(toUnixTime *1000)
//     const diffDays = Math.round(Math.abs((fromUnixTime * 1000 - toUnixTime * 1000) / ONE_DAY));
//     return diffDays
// }
// export const nos_daysAfterForecast = (predictedVolume: number, usageInDay: number) => {
//     //TODO Have to extend this for usage in day MEDIUM & COMPLEX
//     const daysToRunOut = Math.round(predictedVolume / usageInDay)
//     return daysToRunOut
// }

// export const getYieldForecastAverage = (yieldForecast: any, yieldDefault: number) => {
//     let yieldAverage: number = yieldDefault
//     if (yieldForecast.length > 0) {
//         let yieldSum: number = 0
//         yieldForecast.forEach((forecast: any) => {
//             yieldSum = yieldSum + forecast.yield_forecast

//         });
//         // let yieldSum = yieldForecast.reduce((sum: number, current: any) => {  sum + current.yield_forecast,0 })
//         // average_usage = usageInDay. .reduce((sum: number, item: any) => sum + item.usage_in_day, 0) / no_of_days
//         yieldAverage = yieldSum / yieldForecast.length
//     }
//     return yieldAverage
// }

// export const getCombinedEffectiveArea = (collectionAreas: any) => {
//     let combinedEffectiveArea = 0
//     collectionAreas.Items.forEach((item: { effective_area: number; }) => { combinedEffectiveArea += item.effective_area });
//     return combinedEffectiveArea

// }

// export const moreThan24Hours = (previousTimestampMS: number, currentTimestampMS: number, tzOffset: number) => {
//     const timestampDiff = (currentTimestampMS - previousTimestampMS)
//     const moreThanOneDay = timestampDiff > MILLISECONDS_IN_DAY ? true : false
//     return moreThanOneDay
// }

// export const getForecastCollectionInSevenDays = (forecast_Collection_Day: any) => {
//     let aggregateForecastCollection: number = 0
//     forecast_Collection_Day.forEach((day: { forecast_Collected_Volume: any; }) => { aggregateForecastCollection += day.forecast_Collected_Volume });
//     console.log({ aggregateForecastCollection })
//     return aggregateForecastCollection
// }

// export const getYieldActual = (yield_actualArray: any, _yield_actual: any) => {
//     yield_actualArray = yield_actualArray ?? []
//     if (yield_actualArray.length >= 100) yield_actualArray = getNewHistoryArray(yield_actualArray, _yield_actual)
//     else yield_actualArray.unshift(_yield_actual)
//     return yield_actualArray
// }

// export const getYieldActualAverage = (yieldActual: any) => {
//     let yieldAverage: number = 0
//     if (yieldActual && yieldActual.length > 0) {
//         let yieldSum: number = 0
//         yieldActual.forEach((item: any) => {
//             yieldSum = yieldSum + item.yield_actual
//         });
//         yieldAverage = yieldSum / yieldActual.length
//     }
//     return yieldAverage
// }

// export const getUsageInPeriodActual = (previousFillVolume: number, currentFilledVolume: number, actualCollectedVolume: number) => {
//     debug && console.log('getUsageInPeriodActual', { previousFillVolume, currentFilledVolume, actualCollectedVolume });
//     let usage_In_Period_Actual: number = 0
//     if (previousFillVolume > currentFilledVolume) {
//         usage_In_Period_Actual = (previousFillVolume - currentFilledVolume) + actualCollectedVolume
//     }
//     if (previousFillVolume < currentFilledVolume) {
//         usage_In_Period_Actual = actualCollectedVolume - (currentFilledVolume - previousFillVolume)
//     }
//     return usage_In_Period_Actual
// }

// export const getUsageInHourActual = (usageInHourActualArray: any, usageInHourActual: any) => {
//     debug && console.log({ usageInHourActualArray, usageInHourActual });
//     usageInHourActualArray = usageInHourActualArray ?? []
//     if (usageInHourActualArray.length >= 100) usageInHourActualArray = getNewHistoryArray(usageInHourActualArray, usageInHourActual)
//     else usageInHourActualArray.unshift(usageInHourActual)
//     return usageInHourActualArray
// }

// export const getUsageInDayActualHourly = (usageInHourActual: any, yesterday: string, timeOffset: number) => {
//     usageInHourActual = usageInHourActual ?? []
//     let usageInHourActualYesterday: number = 0
//     for (let i = 0; i < usageInHourActual.length && i < 50; i++) {
//         const usageInHourDate = getNZDate(usageInHourActual[i].timestamp, timeOffset)
//         if (usageInHourDate == yesterday) {
//             usageInHourActualYesterday = usageInHourActualYesterday + usageInHourActual[i].usage_In_Period_Assumed
//         }
//     }
//     return usageInHourActualYesterday
// }

// export const getDailyUsage = (usageInDayActual: any) => {
//     if (usageInDayActual.usage_In_Day_Actual_Hourly) {
//         if (usageInDayActual.usage_In_Day_Actual_Hourly > 0) {
//             return usageInDayActual.usage_In_Day_Actual_Hourly
//         } else {
//             if (usageInDayActual.Usage_In_Day_Assumed_Hourly) {
//                 if (usageInDayActual.Usage_In_Day_Assumed_Hourly > 0) {
//                     return usageInDayActual.Usage_In_Day_Assumed_Hourly
//                 } else {
//                     return usageInDayActual.usage_in_day
//                 }
//             }
//         }
//     }
// }
